
import {
  defineComponent, shallowRef, onMounted, ref, watch, computed, onUnmounted,
} from 'vue';
// import caronMap from './components/caronMap.vue';
import {
  Input, Table, ConfigProvider, Tooltip, InputNumber, message, DatePicker,
} from 'ant-design-vue';
import moment, { Moment, } from 'moment';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { CheckOutlined, EditOutlined, QuestionCircleFilled, } from '@ant-design/icons-vue';

import store from '@/store';
import { number, } from 'echarts';

export default defineComponent({
  components: {
    Table,
    InputNumber,
    DatePicker,
  },
  props: {
    itemInfo: {
      type: Object,
      default: () => ({}),
      require: false,
    },
    popType: {
      type: Number,
      default: 1,
    },
  },
  setup (props,{ emit, }) {
    // 列表行配置
    const columns = [
      {
        title: '指标',
        align: 'center',
        dataIndex: 'name',
        key: 'name',
        width: '40%',
      },
      {
        title: '年度目标',
        align: 'center',
        dataIndex: 'norm',
        key: 'norm',
        slots: { customRender: 'norm', },
        width: '60%',
        ellipsis: true,
      },
    ];
    // 表格显示
    const tableData = [
      {
        name: '优良天（天)',
        norm: 'fineDays',
      },
      {
        name: 'PM₂․₅(μg/m³)',
        norm: 'pm25',
      },
      {
        name: 'PM₁₀(μg/m³)',
        norm: 'pm10',
      },
      {
        name: 'SO₂(μg/m³)',
        norm: 'so2',
      },
      {
        name: 'NO₂(μg/m³)',
        norm: 'no2',
      },
      {
        name: 'O₃(μg/m³)',
        norm: 'o3',
      },
      {
        name: 'CO(mg/m³)',
        norm: 'co',
      },
      {
        name: '综合指标',
        norm: 'composite_index',
      },
    ];
    // 双向绑定input数据-表格数据
    const inputData = ref<any>({});
    // 编辑/新增标记
    const isEidtFlag = ref<boolean>(false);
    // 格式化
    const dateFormat = 'YYYY年';
    const isOpen = ref<boolean>(false);
    // 标题
    const titleName = (popType:number) => {
      switch (popType) {
      case 1:
        return '新增';
      case 2:
        return '编辑';
      default:
        return '详情';
      }
    };

    // 取消弹窗
    const cancel = (): void => {
      emit('cancel');
    };
    // 保存弹窗
    const save = (): void => {
      const { year, } = inputData.value;
      const tempPara = {};

      // 无数据则赋空字符串
      Object.keys(inputData.value).forEach((item) => {
        tempPara[item] = inputData.value[item] ?? '';
      });
      const params = {
        ...tempPara,
        year: year ?
          moment(year).format('YYYY') :
          '',
        id: props.itemInfo.id || '',
      };

      store.dispatch('target/updateMonTable',params);
      emit('save');
    };

    // 初始化数据
    const init = (val:any) => {
      tableData.forEach((item) => {
        const tmp = val[item.norm] ?
          val[item.norm][0] :
          '';

        inputData.value[item.norm] = tmp || '';
      });
      inputData.value.year = val.year || '';
    };
    const panelChange = (val:any) => {
      inputData.value.year = val;
      isOpen.value = false;
    };
    const openChange = (status:any) => {
      if (status) {
        isOpen.value = true;
      } else {
        isOpen.value = false;
      }
    };

    watch(props.itemInfo, (val) => {
      if (Object.keys(val).length) {
        isEidtFlag.value = true;
      }
      init(val);
    },{
      deep: true,
      immediate: true,
    });
    onUnmounted(() => {
      inputData.value = {};
    });

    return {
      zhCN,
      columns,
      tableData,
      inputData,
      isEidtFlag,
      dateFormat,
      isOpen,
      titleName,
      panelChange,
      openChange,
      cancel,
      save,
    };
  },
});
